/**
 * ภาพไอคอนสกิลที่วางไว้จริง (`assets/icons/skills/<id สกิล>.png|webp`) — Vite แทนที่ import.meta.glob ตอน build
 * เช็ค typeof ก่อนเรียก: เทสต์ใน node ไม่มี import.meta.glob → ได้รายการว่าง ไม่พัง
 */
export const ICON_FILES: Record<string, string> = typeof import.meta.glob === "function"
  ? import.meta.glob("./assets/icons/skills/*.{png,webp}", { query: "?url", import: "default", eager: true }) as Record<string, string>
  : {};
